export default __webpack_public_path__ + "static/media/tikka-masala.f206b2c5.jpg";